import { render, staticRenderFns } from "./FiltroMandatos.vue?vue&type=template&id=7fc45582"
import script from "./FiltroMandatos.vue?vue&type=script&lang=js"
export * from "./FiltroMandatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports